import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ImagePlus } from 'lucide-react';
import { categoryLabels, ForumCategory } from './forumLabels';

type Props = {
  open: boolean;
  submitting: boolean;
  title: string;
  content: string;
  category: ForumCategory;
  files: File[];
  onClose: () => void;
  onTitleChange: (v: string) => void;
  onContentChange: (v: string) => void;
  onCategoryChange: (v: ForumCategory) => void;
  onFilesChange: (files: File[]) => void;
  onSubmit: () => void;
};

const ForumNewTopicModal: React.FC<Props> = ({
  open,
  submitting,
  title,
  content,
  category,
  files,
  onClose,
  onTitleChange,
  onContentChange,
  onCategoryChange,
  onFilesChange,
  onSubmit,
}) => (
  <AnimatePresence>
    {open && (
      <motion.div
        className="forum-modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => !submitting && onClose()}
      >
        <motion.div
          className="forum-new-topic glow-card"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <h3>Yeni konu</h3>
          <input
            className="forum-input"
            value={title}
            onChange={(e) => onTitleChange(e.target.value)}
            placeholder="Başlık"
          />
          <select
            className="forum-input"
            value={category}
            onChange={(e) => onCategoryChange(e.target.value as ForumCategory)}
          >
            {(Object.keys(categoryLabels) as ForumCategory[]).map((c) => (
              <option key={c} value={c}>
                {categoryLabels[c]}
              </option>
            ))}
          </select>
          <textarea
            className="forum-input forum-input--area"
            value={content}
            onChange={(e) => onContentChange(e.target.value)}
            placeholder="İçerik"
            rows={5}
          />
          <label className="forum-file-label">
            <ImagePlus size={18} /> Görseller (imgbb)
            <input
              type="file"
              accept="image/*"
              multiple
              hidden
              onChange={(e) => onFilesChange(Array.from(e.target.files || []).slice(0, 6))}
            />
          </label>
          {files.length > 0 && <div className="forum-file-hint">{files.length} dosya seçildi</div>}
          <div className="forum-modal-actions">
            <button type="button" className="forum-btn forum-btn--ghost" onClick={onClose}>
              Vazgeç
            </button>
            <button type="button" className="forum-btn forum-btn--primary" disabled={submitting} onClick={onSubmit}>
              {submitting ? 'Gönderiliyor…' : 'Yayınla'}
            </button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default ForumNewTopicModal;
